export default __webpack_public_path__ + "files/media/md-nyas.939430ca.jpg";